import { Component } from '@angular/core';
import { DetailInfoTypeComponent } from '../detail-info-type.component';
import { InputContentDataExtraValueType, InputContentDataType } from 'client/models';
import { FormControl } from '@angular/forms';

// Per-instance sequence so each rendered radio group gets a UNIQUE native `name`. Native HTML radios
// sharing a name form one mutually-exclusive group across the whole document — in a repeatable grid
// that would make all rows' radios for a column one group (selecting a row clears the others). Each
// cell is its own component instance, so a per-instance id scopes the group to a single cell.
let radioGroupSeq = 0;

@Component({
  selector: 'detail-info-radio',
  templateUrl: './detail-info-radio.component.html',
  standalone: false
})
export class DetailInfoRadioComponent extends DetailInfoTypeComponent {

  public InputContentDataExtraValueType = InputContentDataExtraValueType;
  public readonly radioGroupUid = ++radioGroupSeq;
  public dataStringValue;
  public dataStringExtraValue;
  public dataKey;

  ngOnInit() {
    super.ngOnInit();
    const val = this.formControlObj.value;
    this.dataStringExtraValue = val?.dataStringExtraValue ? String(val?.dataStringExtraValue).trim() : '';
    this.dataKey = val?.dataStringValue;
  }

  public selectOption() {
    const optionControl = this.formControlObj as FormControl;
    optionControl.setValue({ dataStringValue: this.dataKey, dataStringExtraValue: this.dataStringExtraValue });
  }

}